<div>
  <div [formGroup]="form">
    <mat-form-field>
      <mat-label>Переменая</mat-label>
      <mat-select formControlName="var">
        <mat-option *ngFor="let v of vars"
                    (click)="varSelected(v, true)"
                    [value]="v.value">
          {{v.name}}
        </mat-option>
      </mat-select>
    </mat-form-field>
    <div *ngIf="isReference == false" class="controls">
      <mat-form-field>
        <mat-label>Оператор</mat-label>
        <mat-select formControlName="op">
          <mat-option *ngFor="let op of ops$ | async" [value]="op.v">
            {{op.name}}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field>
        <mat-label>Значение</mat-label>
          <input matInput type="text" formControlName="val" [matAutocomplete]="autoVal">
          <mat-autocomplete #autoVal="matAutocomplete" panelWidth="auto">
            <mat-option *ngFor="let option of filteredValues | async" [value]="option">
              {{option}}
            </mat-option>
          </mat-autocomplete>

        <ng-template #noBoolRef>
          <input matInput type="text" formControlName="val">
        </ng-template>
      </mat-form-field>
    </div>
    <div *ngIf="isReference">
      <div class="controls">
        <mat-form-field>
          <mat-label>Вуз</mat-label>
          <input matInput type="text" formControlName="university" [matAutocomplete]="auto2">
          <mat-autocomplete #auto2="matAutocomplete">
            <mat-option *ngFor="let option of filteredUniversities | async" [value]="option">
              {{option}}
            </mat-option>
          </mat-autocomplete>
        </mat-form-field>
        <mat-form-field>
          <mat-label>Индикаторы</mat-label>
          <mat-select formControlName="indicators" multiple (closed)="onIndicatorsPanelClose()">
            <mat-form-field class="indicators-filter">
              <input matInput type="text" formControlName="indicatorsFilter">
            </mat-form-field>

            <mat-select-trigger>
              {{form.controls.indicators.value ? form.controls.indicators.value[0] : ''}}
              <span *ngIf="form.controls.indicators.value?.length > 1" class="example-additional-selection">
                (+{{form.controls.indicators.value.length - 1}} 'ещё')
              </span>
            </mat-select-trigger>
            <mat-option *ngFor="let option of filteredUniversityFields | async" [value]="option">
              {{option}}
            </mat-option>

          </mat-select>
        </mat-form-field>
      </div>
      <div class="controls">
        <mat-form-field>
          <mat-label>Способ расчета «похожести»</mat-label>
          <mat-select formControlName="method">
            <mat-option *ngFor="let v of methods" [value]="v">
              {{v.name}}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field>
          <mat-label>Количество</mat-label>
          <input matInput type="number" formControlName="count">
        </mat-form-field>
      </div>
    </div>
  </div>
  <div>
    <button mat-raised-button
            color="primary"
            [disabled]="form.invalid"
            (click)="complete()">{{ buttonLabel }}
    </button>
  </div>
</div>
